import { getApiClient } from "../lib/apiClient";

export const areasOrProjects = async (q) =>
  getApiClient().get({
    url: "/api/suggest/areas_or_projects",
    query: { q },
  });
